import { FormWithRedux } from '../../FormWithRedux';

export class EDChestPainPathwayInformationForm extends FormWithRedux {

    constructor() {
        super('pathwayInformationForm');
    }

    shouldDisplayFormDetailForIdentifier() {
        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return null;
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return this.detail;
    }
}


// WEBPACK FOOTER //
// ./src/forms/edChestPain01/Forms/EDChestPain-PathwayInformationForm.js